const data = [
  {
    title: 'Opus has been updated!',
    text:
      'We’ve made some new changes on our entity level pages for better ease-of-use and improved navigation.',
    imageUrl: 'https://prodwmgcdn-a.akamaihd.net/opus/popup-images/image-1@2x',
  },
  {
    title: 'Opus has been updated!',
    text:
      'Better terminology, helpful icons, and clearer categorization -  our test results shows us that it helps you use Opus better!',
    imageUrl: 'https://prodwmgcdn-a.akamaihd.net/opus/popup-images/image-2@2x',
  },
  {
    title: 'Opus has been updated!',
    text:
      'Some items in the navigation dropdown have been re-categorized for better organization - so be on the lookout for any items that have moved.  Happy Opus-ing!',
    imageUrl: 'https://prodwmgcdn-a.akamaihd.net/opus/popup-images/image-3@2x',
  },
];

export default data;
